import {take, call, put} from 'redux-saga/effects';
import {
	clickAgreeTerms,
	agreeTerms
} from '../actions';
import superFetch from '../modules/superFetch';
import {getApiUrl} from "./index";

export function* handleClickAgreeTerms() {
	while (true) {
		const action = yield take(`${clickAgreeTerms}`);
		const {payload} = yield call(superFetch, {
			url: getApiUrl() + 'agree-terms/',
			type: 'POST',
			data: action.payload
		});
		yield put(agreeTerms(Object.assign({}, payload, {})));
	}
}



// WEBPACK FOOTER //
// ./src/sagas/menu.js